export const connectionType = {
  BLUETOOTH: 'BLUETOOTH',
  CELLULAR: 'CELLULAR',
  ETHERNET: 'ETHERNET',
  MIXED: 'MIXED',
  NONE: 'NONE',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN',
  WIFI: 'WIFI',
  WIMAX: 'WIMAX'
} as const;

export const effectiveConnectionType = {
  TWOG: '2G',
  THREEG: '3G',
  FOURG: '4G',
  SLOW2G: 'SLOW-2G'
} as const;
